import { render, staticRenderFns } from "./MaterialPicker.vue?vue&type=template&id=593322e2"
import script from "./MaterialPicker.vue?vue&type=script&lang=js"
export * from "./MaterialPicker.vue?vue&type=script&lang=js"
import style0 from "./MaterialPicker.vue?vue&type=style&index=0&id=593322e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports